import { AdvancedFilterController } from './advanced-filter.controller'

function advancedFilter () {
  return {
    restrict: 'E',
    scope: {
      filters: '=',
      onFilter: '<',
      saveFilter: '<',
      onSaveFilter: '<'
    },
    templateUrl: '/core/directives/advanced-filter/advanced-filter.html?$$REVISION$$',
    controller: AdvancedFilterController
  }
}
export { advancedFilter }
